/* eslint-disable */

import React, {
  // useContext,
  useState,
  useRef,
  useEffect,
  useContext,
  useMemo,
} from "react"
import PropTypes from "prop-types"
import { useLocation } from "@reach/router"
import axios from "axios"
import { Link } from "gatsby"
import { getSrc } from "gatsby-plugin-image"
import { CgChevronRight as ChevronIcon } from "react-icons/cg"
import RatingsAndComments from "../components/ProductRecommendationv2/RatingsAndComments"
import ProductBottomSection from "../components/DefaultGenericProductv2/ProductBottomSection"
// import { StoreContext } from '../context/StoreContext';
import { sbEditable } from "@storyblok/storyblok-editable"
import { render } from "storyblok-rich-text-react-renderer"
import { useStoryblok } from "../utils/storyblok"
import AddToCart from "../components/AddToCart"
import Tooltip from "../components/Tooltip"
// import AddToWishlist from '../components/AddToWishlist';
import KitProductBox from "../components/KitProductBox"
import PartProductBox from "../components/PartProductBox"
import DynamicComponents from "../components/DynamicComponents"
import DynamicBelowcontents from "../components/DynamicBelowContents"
import "./DefaultCustomProduct.scss"
import Seo from "../components/seo"
import FeaturedProductImagesCarousel from "../components/FeaturedProductImagesCarousel/index"
import collectionHandles from "../utils/collectionHandles"
import YotpoStarRatings from "../components/YotpoStarRatings/index"
import Tab from "../components/Tab/index"
import shipmentNoticeSetter from "../utils/shipmentNoticeHelper"
import NewBadge from "../components/NewBadge"
// eslint-disable-next-line import/no-unresolved, import/extensions
import useProductKitsAndParts from "../hooks/useProductKitsAndParts"
import { StoreContext } from "../context/StoreContext"
import { NewUserContext } from "../context/NewUserContext"
import SelectKitProducts from "../components/SelectKitProducts"
import ShippingIcon from "../assets/ShippingIconV2"
import AdventureAssurance from "../assets/AdventureAssuranceV2"
import Carousel from "react-multi-carousel"
import "./style.scss"
import * as style from "./style.module.scss"
import "react-multi-carousel/lib/styles.css"

const DefaultCustomProduct = props => {
  const location = useLocation()
  const completeUrl = location.href
  const { pageContext } = props
  const {
    product,
    kitsCollection,
    partsCollection,
    storyblokEntry,
    productPageLinks,
    recommendedProducts,
  } = pageContext
  const { metafields } = product
  // const { client } = useContext(StoreContext);
  const carouselRef = React.useRef()

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1025 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 769 },
      items: 2,
    },
  }
  const partsCollectionValues = partsCollection.products?.map(item =>
    item.metafields.filter(metafield => metafield.key === "component-name"),
  )
  const productPageLinksData = productPageLinks?.data
    ? useStoryblok(productPageLinks?.data?.storyblokEntry)
    : { content: null }

  const variantSKU = kitsCollection?.products[0]?.variants[0]?.sku
  const story =
    storyblokEntry && storyblokEntry.length > 0
      ? useStoryblok(storyblokEntry[0].node)
      : { content: null }

  const {
    title,
    shopifyId,
    description,
    descriptionHtml,
    media: images,
    collections,
  } = product
  // state that keeps track of all selected (both kit and part) products, in obj form:
  // {variantId: '', quantity: 1} - variantId utilizes product's default variant's storefrontId
  // const [variants, setVariants] = useState([]);

  // global state that keeps track of all selected products' availability
  const [available, setAvailable] = useState(false)
  const [reviewsData, setReviewsData] = useState()
  const [questionsData, setQuestionsData] = useState()
  const [currentProduct, setCurrentProduct] = useState()

  const myDivRef = useRef(null)

  // global state that keeps track if any products have been selected,
  // used to manage AddToCart state "Select Kit"
  const [noProductSelected, setNoProductSelected] = useState(true)

  // global state that keeps track if any of products selected is preorder,
  // also keeps track of the final preorder date
  const [preorder, setPreorder] = useState({
    preorder: false,
    preorderDate: "",
  })

  // state tht keeps track of all selected products' total price,
  // defaults to being undefined to hide price html on load / when no products are selected
  const [price, setPrice] = useState("")

  const [comparePrice, setComparePrice] = useState("")

  const [imageIndex, setImageIndex] = useState(0)

  // state imported from shippingHours "time left" for available, non-preorder orders
  const [shippingHours, setShippingHours] = useState("Now")

  // state that keeps track of lineItem objects to be directly added to store cart
  const [lineItems, setLineItems] = useState([
    {
      variantId: "",
      quantity: 1,
    },
  ])

  // grabs tooltip text to pass into Tooltip component from each collection (kits and parts)
  const kitsCollectionTooltipText = kitsCollection.metafields.filter(
    metafield => metafield.key === "tooltip-text",
  )[0].value
  const partsCollectionTooltipText = partsCollection.metafields.filter(
    metafield => metafield.key === "tooltip-text",
  )[0].value

  const dropdownValues = kitsCollection.products?.map(item =>
    item.metafields.filter(metafield => metafield.key === "component-name"),
  )
  const { client } = useContext(StoreContext)
  const { addClientDataKit, addClientDataPart } = useProductKitsAndParts({
    product,
    client,
  })

  // creates custom kits and parts array that keep track of each product selected
  const kitProductsArr = [...kitsCollection.products]
  const partProductsArr = [...partsCollection.products]

  // array of all images needed to be loaded into FeaturedProductImagesCarousel component
  const customImages = []

  kitProductsArr.forEach((kitProduct, index) => {
    kitProductsArr[index].selected = false
    customImages.push(kitProduct.featuredImage)
  })

  partProductsArr.forEach((partProduct, index) => {
    partProductsArr[index].selected = false
    customImages.push(partProduct.featuredImage)
  })

  // states that keep track of each selected product along with product data from gatsby-node.js
  const [kitProductsState, setKitProducts] = useState([...kitProductsArr])
  const [partProductsState, setPartProducts] = useState([...partProductsArr])
  const [selectedProductsKlaviyo] = useState()
  const kitProducts = useMemo(
    () => addClientDataKit(kitProductsState),
    [kitProductsState, addClientDataKit],
  )

  const partProducts = useMemo(
    () => addClientDataPart(partProductsState),
    [partProductsState, addClientDataPart],
  )

  // tracking all states here
  // useEffect(() => {
  //   console.log('kitProducts', kitProducts);
  //   console.log('partProducts', partProducts);
  //   console.log('lineItems', lineItems);
  //   console.log('available', available);
  //   console.log('noProductSelected', noProductSQelected);
  //   console.log('preorder', preorder);
  //   console.log('price', price);
  // });

  /* Breadcrumb collection set setup */
  // Default to the first collection
  let collectionIndex = 0

  if (collections.length > 1) {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < collections.length; i++) {
      if (collectionHandles.has(collections[i].handle)) {
        collectionIndex = i
        break
      }
    }
  }

  let categoryName

  if (collections.length) {
    categoryName = collections[collectionIndex].title
  }

  // Extract Product Shopify Id
  const productShopifyId = shopifyId.slice(shopifyId.lastIndexOf("/") + 1)

  // Load Yotpo Reviews Script
  useEffect(() => {
    /* eslint-disable-next-line */
    ;(function e() {
      var e = document.createElement("script")
      ;(e.type = "text/javascript"),
        (e.async = true),
        (e.src =
          "//staticw2.yotpo.com/qNmEg7HN0QiYfqn6n5DHRUGCtTUGNWa1GfSVsHRS/widget.js")
      var t = document.getElementsByTagName("script")[0]
      t.parentNode.insertBefore(e, t)
    })()
  }, [])

  useEffect(() => {
    getReviews()
    getQuestions()
    shipmentNoticeSetter(setShippingHours)
    const shipmentTimer = setInterval(() => {
      shipmentNoticeSetter(setShippingHours)
    }, 5000)

    return () => clearTimeout(shipmentTimer)
  }, [])

  // updates variants and lineItems states when a kitProduct's selected state is toggled
  useEffect(() => {
    const selectedKitVariants = kitProducts.filter(
      currentProduct => currentProduct.selected === true,
    )
    const selectedPartVariants = partProducts.filter(
      currentProduct => currentProduct.selected === true,
    )

    const selectedProducts = [...selectedKitVariants, ...selectedPartVariants]
    let totalPrice = 0
    let totalComparePrice = 0

    let currentPreorder = false
    let collectivePreorderDate

    const selectedVariants = []

    selectedProducts.forEach(currentlySelectedProduct => {
      const quantity = currentlySelectedProduct.variants[0].inventoryQuantity
      const currentAvailable =
        currentlySelectedProduct.variants[0].availableForSale
      const inventoryPolicy =
        currentlySelectedProduct.variants[0].inventoryPolicy === "CONTINUE"

      let preorderDate

      const currentPrice = parseFloat(
        currentlySelectedProduct.variants[0].price,
      )
      let currentComparePrice
      if (currentlySelectedProduct.variants[0].compareAtPrice) {
        currentComparePrice = parseFloat(
          currentlySelectedProduct.variants[0].compareAtPrice,
        )
      } else {
        currentComparePrice = 0
      }

      totalPrice += currentPrice
      totalComparePrice += currentComparePrice

      // grabs selected currentlySelectedProduct's preorder date
      const preorderMetafieldArr =
        currentlySelectedProduct.variants[0].metafields.filter(
          metafield => metafield.key === "preorder-date",
        )

      // customAttributes is an optional additional prop passed when adding to cart,
      // is appended if the currentlySelectedProduct is a preorder item,
      // with the corresponding preorder date
      const customAttributes = []

      if (quantity <= 0 && currentAvailable && inventoryPolicy) {
        currentPreorder = true

        if (preorderMetafieldArr.length > 0) {
          preorderDate = preorderMetafieldArr[0].value
        } else {
          preorderDate = "pending"
        }

        customAttributes.push({
          key: "Preorder - Shipping",
          value: preorderDate,
        })
      }

      // compare preorder dates here, collectivePreorderDate is used to set the global preorder date
      // if multiple preorder items are selected, the latest preorder date is set
      if (!collectivePreorderDate) {
        collectivePreorderDate = preorderDate
      } else {
        const current = new Date(collectivePreorderDate).getTime()
        const next = new Date(preorderDate).getTime()
        if (next > current) {
          collectivePreorderDate = preorderDate
        }
      }

      const obj = {
        variantId: "",
        quantity: 1,
      }

      if (customAttributes.length > 0) {
        obj.customAttributes = customAttributes
      }

      // uses currentlySelectedProduct's default variant's storefrontId to add to cart
      obj.variantId = currentlySelectedProduct.variants[0].storefrontId
      selectedVariants.push(obj)
    })

    // if price is 0, or no products are selected,
    // price state is set to '' which hides the price element
    if (totalPrice === 0) {
      setPrice("")
    } else {
      const formattedPrice = `$${totalPrice.toFixed(2)}`
      setPrice(formattedPrice)
    }

    if (totalComparePrice === 0) {
      setComparePrice("")
    } else {
      const formattedComparePrice = `$${totalComparePrice.toFixed(2)}`
      setComparePrice(formattedComparePrice)
    }

    if (selectedVariants.length > 0 && !currentPreorder) {
      setAvailable(true)
      setNoProductSelected(false)
    } else if (selectedVariants.length > 0 && currentPreorder) {
      setAvailable(true)
      setNoProductSelected(false)
    } else {
      setAvailable(false)
      setNoProductSelected(true)
    }

    setPreorder({
      preorder: currentPreorder,
      preorderDate: collectivePreorderDate,
    })

    setLineItems(selectedVariants)
  }, [kitProducts])

  // updates variants and lineItems states when a partProduct's selected state is toggled
  useEffect(() => {
    const selectedKitVariants = kitProducts.filter(
      currentProduct => currentProduct.selected === true,
    )
    const selectedPartVariants = partProducts.filter(
      currentProduct => currentProduct.selected === true,
    )

    const selectedProducts = [...selectedKitVariants, ...selectedPartVariants]

    let totalPrice = 0

    let currentPreorder = false
    let collectivePreorderDate

    const selectedVariants = []

    selectedProducts.forEach(currentlySelectedProduct => {
      const quantity = currentlySelectedProduct.variants[0].inventoryQuantity
      const currentAvailable =
        currentlySelectedProduct.variants[0].availableForSale
      const inventoryPolicy =
        currentlySelectedProduct.variants[0].inventoryPolicy === "CONTINUE"

      let preorderDate

      const currentPrice = parseFloat(
        currentlySelectedProduct.variants[0].price,
      )

      totalPrice += currentPrice

      // grabs selected currentlySelectedProduct's preorder date
      const preorderMetafieldArr =
        currentlySelectedProduct.variants[0].metafields.filter(
          metafield => metafield.key === "preorder-date",
        )

      // customAttributes is an optional additional prop passed when adding to cart,
      // is appended if the currentlySelectedProduct is a preorder item,
      // with the corresponding preorder date
      const customAttributes = []

      if (quantity <= 0 && currentAvailable && inventoryPolicy) {
        currentPreorder = true

        if (preorderMetafieldArr.length > 0) {
          preorderDate = preorderMetafieldArr[0].value
        } else {
          preorderDate = "pending"
        }

        customAttributes.push({
          key: "Preorder - Shipping",
          value: preorderDate,
        })
      }

      // compare preorder dates here, collectivePreorderDate is used to set the global preorder date
      // if multiple preorder items are selected, the latest preorder date is set
      if (!collectivePreorderDate) {
        collectivePreorderDate = preorderDate
      } else {
        const current = new Date(collectivePreorderDate).getTime()
        const next = new Date(preorderDate).getTime()
        if (next > current) {
          collectivePreorderDate = preorderDate
        }
      }

      const obj = {
        variantId: "",
        quantity: 1,
      }

      if (customAttributes.length > 0) {
        obj.customAttributes = customAttributes
      }

      // uses currentlySelectedProduct's default variant's storefrontId to add to cart
      obj.variantId = currentlySelectedProduct.variants[0].storefrontId
      selectedVariants.push(obj)
    })

    // if price is 0, or no products are selected,
    // price state is set to '' which hides the price element
    if (totalPrice === 0) {
      setPrice("")
    } else {
      const formattedPrice = `$${totalPrice.toFixed(2)}`
      setPrice(formattedPrice)
    }

    if (selectedVariants.length > 0 && !currentPreorder) {
      setAvailable(true)
      setNoProductSelected(false)
    } else if (selectedVariants.length > 0 && currentPreorder) {
      setAvailable(true)
      setNoProductSelected(false)
    } else {
      setAvailable(false)
      setNoProductSelected(true)
    }

    setPreorder({
      preorder: currentPreorder,
      preorderDate: collectivePreorderDate,
    })

    setLineItems(selectedVariants)
  }, [partProducts])

  // event listener callback function that runs when a partProductBox is selected/deselected
  const onPartProductBoxSelect = (index, event) => {
    event.preventDefault()

    const currentProducts = [...partProducts]

    const selected = !currentProducts[index].selected

    currentProducts[index] = {
      ...currentProducts[index],
      selected,
    }

    setImageIndex(index + kitProducts.length)

    setPartProducts(currentProducts)
  }
  let notice = ""

  if (!available) {
    notice = <span className="text-red">OUT OF STOCK</span>
  } else if (preorder.preorder) {
    notice = (
      <div>
        <span className="text-paloverde">PREORDER NOW! </span>
        <span>
          Order ships
          {` ${preorder.preorderDate || ""}`}.
        </span>
      </div>
    )
  } else {
    notice = (
      <div>
        <span className="text-paloverde">IN STOCK! </span>
        <span>
          Order
          {` ${shippingHours}`}.
        </span>
      </div>
    )
  }

  useEffect(() => {
    const script = document.createElement("script")
    script.src =
      "https://staticw2.yotpo.com/qNmEg7HN0QiYfqn6n5DHRUGCtTUGNWa1GfSVsHRS/widget.js"
    script.async = true
    document.head.appendChild(script)

    script.onload = () => {
      window.yotpo.refreshWidgets()
    }

    return () => {
      script.remove()
    }
  }, [])

  // eslint-disable-next-line
  const stickyNavComponent =
    story.content && story.content.sticky_nav
      ? story.content.sticky_nav.map(blok => (
          <>
            {/* eslint-disable-line */}
            {blok ? (
              <div {...sbEditable(blok)} className="relative">
                {/* eslint-disable-line */}
                <DynamicComponents
                  blok={blok}
                  product={product}
                  key={blok._uid}
                />
                {/* eslint-disable-line */}
              </div>
            ) : null}
          </>
        ))
      : null

  const [
    BottomSectionImage1,
    BottomSectionImage2,
    sections,
    features,
    overview,
  ] = useMemo(() => {
    return [
      story?.content?.BottomSectionImage1,
      story?.content?.BottomSectionImage2,
      story?.content?.sections,
      render(story?.content?.features),
      render(story?.content?.overview),
    ]
  }, [story])

  /* eslint-disable */
  const BelowContentSectionComponents =
    story.content && story.content.below_content
      ? story.content.below_content.map(blok => (
          <>
            {blok ? (
              <div {...sbEditable(blok)}>
                <DynamicBelowcontents blok={blok} key={blok._uid} />
              </div>
            ) : null}
          </>
        ))
      : null

  /* eslint-enable */

  const newBadge = story.content && story.content.newBadge ? <NewBadge /> : null
  const { cartOverlay } = useContext(NewUserContext)

  const [showDiv, setShowDiv] = useState(false)
  useEffect(() => {
    const handleScroll = () => {
      const isNearBottom =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 500
      if (isNearBottom) {
        setShowDiv(false)
      } else if (window.scrollY > 3000 && !showDiv) {
        // setShowDiv(true)
      } else if (window.scrollY <= 3000 && showDiv) {
        setShowDiv(false)
      }
    }

    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [showDiv])
  const shopifyIdExtractor = id => id.slice(id.lastIndexOf("/") + 1)

  const productId = shopifyIdExtractor(shopifyId)

  const getReviews = async () => {
    await axios
      .post("/.netlify/functions/get-reviews", {
        product_id: productId,
      })
      .then(async res => {
        setReviewsData(res?.data?.response)
      })
      .catch(err => {
        console.error(err, "error")
      })
  }

  const getQuestions = async () => {
    await axios
      .post("/.netlify/functions/get-questions", {
        product_id: productId,
      })
      .then(async res => {
        setQuestionsData(res?.data?.response)
      })
      .catch(err => {
        console.error(err, "error")
      })
  }

  const handleClick = () => {
    myDivRef.current.scrollIntoView({ behavior: "smooth" })
  }

  const KlaviyoScript = () => {
    useEffect(() => {
      if (selectedProductsKlaviyo) {
        // Load Klaviyo script
        const klaviyoScript = document.createElement("script")
        klaviyoScript.src =
          "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=LFDYCZ"
        klaviyoScript.async = true
        document.head.appendChild(klaviyoScript)
        // Execute inline script
        const inlineScript = document.createElement("script")
        inlineScript.innerHTML = `
    try {
    var item = {
    "ProductName": "${title}",
    "ProductID": "${productShopifyId}",
    "SKU": "${variantSKU}",
    "Categories": "${categoryName}",
    "ImageURL": "${selectedProductsKlaviyo[0]?.featuredImage.originalSrc}",
    "URL": "${completeUrl}",
    "Brand": "PolarPro",
    "Price": ${selectedProductsKlaviyo[0]?.variants[0]?.price},
    "CompareAtPrice": ${selectedProductsKlaviyo[0]?.variants[0]?.compareAtPrice}
    };
    _learnq.push(["track", "Viewed Product", item]);
    } catch(error) {
    console.error("Error:", error);
    }
    `
        document.head.appendChild(inlineScript)
      }
    }, [selectedProductsKlaviyo])
    return null
  }

  // Collection script
  const RetensionCollection = () => {
    useEffect(() => {
      const script = document.createElement("script")
      script.type = "text/javascript"
      script.async = true
      script.innerHTML = `
      !function(){var geq=window.geq=window.geq||[];
      if(geq.initialize) return;
      if (geq.invoked){if (window.console && console.error) {console.error("GE snippet included twice.");}
      return;}geq.invoked = true;geq.methods = ["page", "suppress", "trackOrder", "identify", "addToCart", "callBack",
       "event"];geq.factory = function(method){return function(){var args = Array.prototype.slice.call(arguments);
        args.unshift(method);geq.push(args);return geq;};};for (var i = 0; i < geq.methods.length; i++) 
        {var key = geq.methods[i];geq[key] = geq.factory(key);}geq.load = function(key)
        {var script = document.createElement("script");
        script.type = "text/javascript";script.async = true;
        if (location.href.includes("vge=true")) 
        {script.src = "https://s3-us-west-2.amazonaws.com/jsstore/a/" + key + "/ge.js?v=" + Math.random();} 
        else {script.src = "https://s3-us-west-2.amazonaws.com/jsstore/a/" + key + "/ge.js";}
        var first = document.getElementsByTagName("script")[0];first.parentNode.insertBefore(script, first);};
        geq.SNIPPET_VERSION = "1.6.1";
      geq.load("E82H7M9");}();
    `
    }, [])
    return null
  }

  // Suppression script

  const RetensionSuppression = () => {
    useEffect(() => {
      const geqScript = document.createElement("script")
      geqScript.type = "text/javascript"
      geqScript.async = true
      geqScript.innerHTML = `
    !function(){var geq=window.geq=window.geq||[];
      if(geq.initialize) return;if (geq.invoked){if (window.console && console.error) 
      {console.error("GE snippet included twice.");}return;}
      geq.invoked = true;geq.methods = ["page", "suppress", "trackOrder", "identify", "addToCart", "callBack", "event"];
      geq.factory = function(method){return function(){var args = Array.prototype.slice.call(arguments);
        args.unshift(method);geq.push(args);return geq;};};for (var i = 0; i < geq.methods.length; i++) 
        {var key = geq.methods[i];geq[key] = geq.factory(key);}geq.load = function(key)
        {var script = document.createElement("script");
        script.type = "text/javascript";script.async = true;
        if (location.href.includes("vge=true")) 
        {script.src = "https://s3-us-west-2.amazonaws.com/jsstore/a/" + key + "/ge.js?v=" + Math.random();} 
        else {script.src = "https://s3-us-west-2.amazonaws.com/jsstore/a/" + key + "/ge.js";}
        var first = document.getElementsByTagName("script")[0];
        first.parentNode.insertBefore(script, first);};geq.SNIPPET_VERSION = "1.6.1";
      geq.load("E82H7M9");}();
    `

      document.head.appendChild(geqScript)
    }, [])
    return null
  }

  const { email, orderId, totalPrice } = useMemo(() => {
    let email
    let totalPrice
    let orderId

    if (typeof window !== "undefined" && localStorage) {
      email = localStorage.getItem("email")
      totalPrice = localStorage.getItem("totalPrice")
      orderId = localStorage.getItem("orderId")
    }

    return {
      email,
      totalPrice,
      orderId,
    }
  }, [])

  // Revenue script

  const RetensionRevenue = () => {
    useEffect(() => {
      const geqScript = document.createElement("script")
      geqScript.type = "text/javascript"
      geqScript.async = true
      geqScript.innerHTML = `
    !function(){var geq=window.geq=window.geq||[];
      if(geq.initialize) return;if (geq.invoked){if (window.console && console.error) 
        {console.error("GE snippet included twice.");}
        return;}geq.invoked = true;geq.methods = ["page", "suppress", "trackOrder", "identify", "addToCart", "callBack", "event"];
        geq.factory = function(method){return function(){var args = Array.prototype.slice.call(arguments);
          args.unshift(method);geq.push(args);return geq;};};
          for (var i = 0; i < geq.methods.length; i++) {var key = geq.methods[i];geq[key] = geq.factory(key);}
          geq.load = function(key){var script = document.createElement("script");
          script.type = "text/javascript";script.async = true;
          if (location.href.includes("vge=true")) 
          {script.src = "https://s3-us-west-2.amazonaws.com/jsstore/a/" + key + "/ge.js?v=" + Math.random();} 
          else {script.src = "https://s3-us-west-2.amazonaws.com/jsstore/a/" + key + "/ge.js";}
          var first = document.getElementsByTagName("script")[0];first.parentNode.insertBefore(script, first);};
          geq.SNIPPET_VERSION = "1.6.1";
      geq.load("E82H7M9");}();
    `

      document.head.appendChild(geqScript)
    }, [])
    useEffect(() => {
      // const trackOrderScript = document.createElement('script');
      // trackOrderScript.type = 'text/javascript';
      // trackOrderScript.innerHTML = `geq.trackOrder({order_number: "{{ ${orderId} }}",
      // order_amount: "{{ ${totalPrice} }}", order_email: "{{ ${email} }}"})`;
      // document.head.appendChild(trackOrderScript);
    }, [])
    return null
  }

  const singleVariantIncludedList = useMemo(() => {
    if (currentProduct !== undefined) {
      try {
        return (
          JSON.parse(
            currentProduct?.metafields?.filter(
              field => field.key === "included_list",
            )?.[0]?.value,
          ) || []
        )
      } catch (err) {
        return []
      }
    }
  }, [currentProduct])

  return (
    <>
      {/* <RetensionRevenue/> */}
      <RetensionCollection />
      <RetensionSuppression />

      {images.length ? (
        <Seo
          title={title}
          description={description}
          image={getSrc(images[0].image.gatsbyImageData)}
        />
      ) : (
        <Seo title={title} description={description} />
      )}
      <div className="sticky top-0 z-50">{stickyNavComponent}</div>
      <div className="w-full min-h-screen flex justify-between items-start ">
        {/*  Left section */}
        <div className="w-full overflow-hidden">
          <div className="">
            <div className="relative">
              {/** ************************************* */}
              {/** *** Left Section of Product Page **** */}
              {/** ************************************* */}

              {/* Breadcrumb */}
              <div className="flex absolute -top-14 text-sm items-center flex-row">
                <Link
                  to={`/${location.search ? location.search : ""}`}
                  className="hover:underline hover:pointer mr-3 mt-1 text-obsidian text-xs font-medium"
                >
                  Home
                </Link>
                {collections.length ? (
                  <ChevronIcon
                    className="mt-[0.2rem] mr-3 text-obsidian"
                    size={8}
                  />
                ) : (
                  ""
                )}
                {collections.length ? (
                  <Link
                    to={`/collections/${collections[collectionIndex].handle}/${
                      location.search ? location.search : ""
                    }`}
                    className="hover:underline hover:pointer mr-3 mt-1 text-obsidian text-xs font-medium"
                  >
                    {collections[collectionIndex].title}
                  </Link>
                ) : (
                  ""
                )}
                {/* <ChevronIcon className="mr-2 text-grey-dark" size={12} /> */}
                <p className="mr-3 mt-1 mb-0 text-obsidian text-xs font-medium">
                  <span className="mr-3">/</span>
                  {product.title}
                </p>
              </div>
              {newBadge ? <div className="md:hidden">{newBadge}</div> : null}
              <div className="mt-4">
                {/* Product Image Carousel Starts */}
                <div className="px-[20px] lg:px-10 md:h-[900px] featuredImageSpace">
                  <FeaturedProductImagesCarousel
                    images={images}
                    title={title}
                    imageIndex={imageIndex}
                  />
                </div>
                {/* Product Image Carousel Ends */}

                {/** ************************************** */}
                {/** *** Right Section of Product Page **** */}
                {/** ************************************** */}
                <div className="metaSection mt-8 hidden">
                  <span className="labelFont">Type</span>
                  <span className="tagList">
                    <Link
                      to={`${product.productTypeSlug}}/${
                        location.search ? location.search : ""
                      }`}
                    >
                      {product.productType}
                    </Link>
                  </span>
                  <span className="labelFont">Tags</span>
                  <span className="tagList">
                    {product.tags.map(tag => (
                      <Link
                        to={`/search?t=${tag}/${
                          location.search ? location.search : ""
                        }`}
                      >
                        {tag}
                      </Link>
                    ))}
                  </span>
                </div>
                <br />
                <div>
                  <div className="mt-6 lg:hidden px-[20px]">
                    {/* Product Title, description, configuration, options, etc... */}
                    <h1 className="header mb-2 text-2xl font-extrabold font-condensed">
                      {title}
                    </h1>
                    {/* <p className="mb-0 text-xxs text-grey">SKU: {variantSKU}</p> */}
                    {/* Yotpo Star Ratings */}
                    <div role="button" className="relative z-50">
                      <YotpoStarRatings
                        product={product}
                        productShopifyId={productShopifyId}
                      />
                    </div>
                    <div className="flex flex-col">
                      <div className="flex">
                        <h2 className="priceValue mt-1 font-semibold text-xl mb-4 inline">
                          <span>{price}</span>
                        </h2>
                        <h2 className="comparePriceValue inline line-through italic ml-[15px]">
                          <span>{comparePrice}</span>
                        </h2>
                      </div>
                      {/* In stock message: 3 possible states - noProductSelected (hides message);
  all product(s) selected are avaialable (displays in stock message);
  one or more product(s) selected is not available/preorder status -
  (displays preorder message with final preorder date);
  note: out of stock products that aren't available or preorder are not selectable */}
                      {/* <p className="text-xs font-bold font-condensed mt-4">
                      {noProductSelected ? "" : notice}
                    </p> */}
                      <p className="font-bold font-condensed text-sm inline-block">
                        {kitsCollection.title}:
                      </p>
                    </div>
                    <Tooltip tooltipText={kitsCollectionTooltipText} />
                    <div className="productSelectContainer">
                      {/* {kitsCollection.products.map((productItem, index) => (
                        <div>
                          <KitProductBox
                            productItem={productItem}
                            setKitProducts={setKitProducts}
                            index={index}
                            kitProductsState={kitProductsState}
                          />
                        </div>
                                ))} */}
                      <SelectKitProducts
                        values={dropdownValues}
                        setKitProducts={setKitProducts}
                        kitProductsState={kitProductsState}
                      />
                    </div>
                    {partsCollection.products.length > 0 ? (
                      <div>
                        <p className="font-bold font-condensed text-sm inline-block">
                          {partsCollection.title}:
                        </p>
                        <Tooltip tooltipText={partsCollectionTooltipText} />
                        <div className="productSelectContainer">
                          {partsCollection.products.map(
                            (productItem, index) => (
                              <div>
                                <PartProductBox
                                  productItem={productItem}
                                  onPartProductBoxSelect={
                                    onPartProductBoxSelect
                                  }
                                  index={index}
                                />
                              </div>
                            ),
                          )}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {/* eslint-disable-next-line */}
                    <div className="self-end items-center w-full flex-col justify-between xl:flex-row xl:w-auto">
                      <div className="justify-end xl:justify-center w-full mb-2 xl:w-auto xl:mb-0">
                        <AddToCart
                          productLists={lineItems}
                          available={available}
                          noProductSelected={noProductSelected}
                          preorder={preorder.preorder}
                          style={{ maxWidth: "none" }}
                          price={price}
                          productName={product.title}
                          categoryName={collections[collectionIndex].title}
                        />
                      </div>
                      {/* //Add To Wish List
                       <div className="flex justify-end xl:justify-center w-full xl:w-auto">
                       <AddToWishlist />
                       </div>
                       */}
                    </div>
                  </div>
                </div>
                {/* Mobile end of scrolll */}
                {showDiv && (
                  <div
                    style={{ zIndex: cartOverlay ? "999999" : "50" }}
                    className="lg:hidden bottom-0 h-[200px] shadow-xl overflow-scroll bg-white px-6 fixed duration-300 ease-in-out transform w-full z-50"
                  >
                    <h1 className="header mb-2 !text-[17px] py-4  font-extrabold font-condensed">
                      {title}
                    </h1>

                    <p className="font-bold font-condensed text-sm inline-block">
                      {kitsCollection.title}:
                    </p>
                    <Tooltip tooltipText={kitsCollectionTooltipText} />
                    <div className="productSelectContainer">
                      {kitsCollection.products.map((productItem, index) => (
                        <div>
                          <KitProductBox
                            productItem={productItem}
                            setKitProducts={setKitProducts}
                            index={index}
                            kitProductsState={kitProductsState}
                          />
                        </div>
                      ))}
                    </div>

                    {partsCollection.products.length > 0 ? (
                      <div>
                        <p className="font-bold font-condensed text-sm inline-block">
                          {partsCollection.title}:
                        </p>
                        <Tooltip tooltipText={partsCollectionTooltipText} />
                        <div className="productSelectContainer">
                          {partsCollection.products.map(
                            (productItem, index) => (
                              <div>
                                <PartProductBox
                                  productItem={productItem}
                                  onPartProductBoxSelect={
                                    onPartProductBoxSelect
                                  }
                                  index={index}
                                />
                              </div>
                            ),
                          )}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {/* eslint-disable-next-line */}
                    <div className="self-end items-center w-full flex-col justify-between xl:flex-row xl:w-auto">
                      <div className="justify-end xl:justify-center w-full mb-2 xl:w-auto xl:mb-0">
                        <AddToCart
                          productLists={lineItems}
                          available={available}
                          noProductSelected={noProductSelected}
                          preorder={preorder.preorder}
                          style={{ maxWidth: "none" }}
                          price={price}
                          productName={product.title}
                          categoryName={collections[collectionIndex].title}
                        />
                      </div>
                      {/* //Add To Wish List
                       <div className="flex justify-end xl:justify-center w-full xl:w-auto">
                       <AddToWishlist />
                       </div>
                       */}
                    </div>
                  </div>
                )}

                {features && overview ? (
                  <div className="mx-auto pt-[13px] md:pt-[20px] relative z-20 px-[20px] md:px-0 flex flex-col md:flex-row justify-center gap-[30px] md:gap-[112px]">
                    <div className="w-full md:w-[40%] lg:w-[35%] feature-overview-divider">
                      <p className="font-sans font-black text-[30px]">
                        Overview
                      </p>
                      <div className="text-base text-[15px] leading-[22px]">
                        {overview}
                      </div>
                    </div>
                    <div className="w-full md:w-[40%] lg:w-[35%]">
                      <p className="font-sans font-black text-[30px]">
                        Features
                      </p>

                      <div className=" list_styling text-base text-[15px] leading-[18px]">
                        {features}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className=" pt-[13px] md:pt-[80px] px-[20px] sm:px-[60px] lg:px-[110px] ">
                    <div
                      className=""
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{ __html: descriptionHtml }}
                    />
                  </div>
                )}

                {story?.content?.cases_and_components?.length &&
                  story?.content?.user_guide?.length && (
                    <div className="border-y-[#eseses] border-t border-solid border-b flex flex-col h-auto sm:h-[120px] gap-6 sm:flex-row mt-8 justify-center text-center px:4 sm:px-0 bg-gray-100 items-center gap-0 sm:gap-[80px] md:gap-[100px] lg:gap-[150px] text-gray-500">
                      <Link
                        to={
                          story?.content?.cases_and_components[0]?.link?.url ||
                          story?.content?.cases_and_components[0]?.link
                        }
                        className="border-b sm:border-b-0 hover:border-b w-full sm:w-fit"
                      >
                        <p className="m-0 my-10 sm:my-0 text-md md:text-md lg:text-xl cursor-pointer hover:text-black hover:border-b-[1px] hover:border-black font-black font-sans inline-block xs:block">
                          {story?.content?.cases_and_components[0]?.title}
                        </p>
                      </Link>

                      <Link
                        to={
                          story?.content?.user_guide[0]?.link?.url ||
                          story?.content?.user_guide[0]?.link
                        }
                      >
                        <p className="m-0 my-10 sm:my-0 text-md md:text-md lg:text-xl cursor-pointer hover:text-black hover:border-b-[1px] hover:border-black font-black font-sans">
                          {story?.content?.user_guide[0]?.title}
                        </p>
                      </Link>
                    </div>
                  )}
              </div>
            </div>
          </div>
          {sections?.length ? (
            <ProductBottomSection
              sections={sections}
              BottomSectionImage1={BottomSectionImage1}
              BottomSectionImage2={BottomSectionImage2}
            />
          ) : (
            BelowContentSectionComponents
          )}

          {recommendedProducts.length < 4 ? (
            <Tab
              product={product}
              productShopifyId={productShopifyId}
              recommendedProducts={recommendedProducts}
            />
          ) : (
            <div className="recommendedProdutsContainer w-full md:px-[75px] block relative">
              <div className="absolute leftArrow">
                <button
                  type="button"
                  onClick={() => carouselRef.current.previous()}
                  className="w-[42px] h-[42px] bg-[gray] hover:bg-[#C99E1A] rounded-full relative"
                ></button>
              </div>
              <div className="absolute rightArrow">
                <button
                  type="button"
                  onClick={() => carouselRef.current.next()}
                  className="w-[42px] h-[42px] bg-[gray] hover:bg-[#C99E1A] rounded-full relative"
                ></button>
              </div>
              <Carousel
                responsive={responsive}
                swipeable
                ref={carouselRef}
                arrows={false}
                draggable
                showDots
                infinite
                renderDotsOutside
                containerClass={`${style.sixConfig} sixConfigArrow reconCustomSlider productRecommendationCustomSlider`}
                dotListClass={`${style.reconCustomDotSlider} ${style.sixConfig} reconCustomDotSlider`}
              >
                {recommendedProducts.map(recommendedProduct => {
                  if (recommendedProduct) {
                    return (
                      <a
                        href={`/products/${recommendedProduct.handle}`}
                        className="pointer-events-none"
                      >
                        <div className="recommendedProductCard w-full">
                          <img
                            src={recommendedProduct.featuredImage.originalSrc}
                            alt={recommendedProduct.title}
                          />
                          <p className="font-bold text-[14px] pointer-events-none">
                            {recommendedProduct.title}
                          </p>
                          <div className="recommendedProductCardData !static">
                            {recommendedProduct.metafields
                              .filter(
                                metafield =>
                                  metafield.key === "quickview-content",
                              )
                              .map(metafield => (
                                <p
                                  className="text-[12px] leading-normal recProductDesc pointer-events-none"
                                  dangerouslySetInnerHTML={{
                                    __html: metafield.value,
                                  }}
                                />
                              ))}
                            <p className="font-bold text-[14px] pointer-events-none">
                              From $
                              {parseFloat(
                                recommendedProduct.priceRangeV2.minVariantPrice
                                  .amount,
                              ).toFixed(2)}
                            </p>
                          </div>
                        </div>
                      </a>
                    )
                  }
                  return null
                })}
              </Carousel>
            </div>
          )}
          {/* Ratings and Commets */}
          <div ref={myDivRef} className="mx-7 mt-10">
            <div className="max-w-screen-xl m-auto mt-2 pt-10 border-t">
              <RatingsAndComments
                product={product}
                productShopifyId={productShopifyId}
                reviewData={reviewsData}
                product_id={productId}
                questionsData={questionsData}
              />
            </div>
          </div>
        </div>
        {/* Right section */}
        <div className="sticky top-0 overflow-auto right-0 hidden lg:block bg-white pt-[40px] p-7 lg:sticky lg:top-0 pb-16 lg:right-0 lg:border lg:border-[#E5E5E5] lg:min-h-[calc(100vh-140px)] overflow-x-hidden lg:max-w-sm lg:min-w-[384px] w-full h-[100vh]">
          <div className="p-0 max-w-[545px] md:pb-[25px]">
            {/* Product Title, description, configuration, options, etc... */}
            <h1 className="header mb-2 text-2xl font-extrabold font-condensed">
              {title}
            </h1>
            {/* <p className="mb-0 text-xxs text-grey">SKU: {variantSKU}</p> */}
            {/* Yotpo Star Ratings */}
            <div
              className="relative z-50"
              role="button"
              onClick={() => handleClick()}
              tabIndex={0}
              onKeyDown={() => handleClick()}
            >
              <YotpoStarRatings
                product={product}
                productShopifyId={productShopifyId}
              />
            </div>
            <div className="flex flex-col">
              <div className="flex flex-row">
                <h2 className="priceValue mt-1 font-semibold text-xl mb-4 inline">
                  <span>{price}</span>
                </h2>
                <h2 className="comparePriceValue inline line-through italic ml-[15px]">
                  <span>{comparePrice}</span>
                </h2>
              </div>
              {/* In stock message: 3 possible states - noProductSelected (hides message);
  all product(s) selected are avaialable (displays in stock message);
  one or more product(s) selected is not available/preorder status -
  (displays preorder message with final preorder date);
  note: out of stock products that aren't available or preorder are not selectable */}
              {/* <p className="text-xs font-bold font-condensed mt-4">
              {noProductSelected ? "" : notice}
            </p> */}
              {singleVariantIncludedList?.length > 0 ? (
                <div>
                  <p className="font-medium text-[#1C1C1C] text-sm mb-2">
                    includes:
                  </p>
                  <div className="mb-2">
                    {singleVariantIncludedList.map(val => (
                      <div className="flex gap-1  ">
                        <div className="border-[1px] p-[1px] border-black w-2 h-2 rounded-full mt-1">
                          <div className="bg-black w-full h-full  rounded-full">
                            {" "}
                          </div>
                        </div>
                        <p className="text-sm text-[#1C1C1C] font-sans mb-0 font-bold">
                          {val}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                ""
              )}
              <p className="font-bold font-condensed text-sm inline-block">
                {kitsCollection.title}:
              </p>
            </div>
            <Tooltip tooltipText={kitsCollectionTooltipText} />
            <div className="productSelectContainer">
              <SelectKitProducts
                values={dropdownValues}
                setKitProducts={setKitProducts}
                kitProductsState={kitProductsState}
                setImageIndex={setImageIndex}
                setCurrentProduct={setCurrentProduct}
              />
            </div>
            {partsCollection.products.length > 0 ? (
              <div>
                <p className="font-bold font-condensed text-sm inline-block">
                  {partsCollection.title}:
                </p>
                <Tooltip tooltipText={partsCollectionTooltipText} />
                <div className="productSelectContainer">
                  <div>
                    <SelectKitProducts
                      values={partsCollectionValues}
                      setKitProducts={setPartProducts}
                      kitProductsState={partProductsState}
                      setImageIndex={setImageIndex}
                      forImageIndex={kitProducts.length}
                    />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {/* eslint-disable-next-line */}
            <div className="self-end items-center w-full flex-col justify-between xl:flex-row xl:w-auto">
              <div className="justify-end xl:justify-center w-full mb-2 xl:w-auto xl:mb-0">
                <AddToCart
                  productLists={lineItems}
                  available={available}
                  noProductSelected={noProductSelected}
                  preorder={preorder.preorder}
                  style={{ maxWidth: "none" }}
                  price={price}
                  productName={product.title}
                  categoryName={collections[collectionIndex].title}
                />
              </div>
              <div className="mt-5">
                {!noProductSelected &&
                  kitsCollection?.products[0]?.variants[0]?.sku && (
                    <div className="w-full flex items-start text-[#1c1c1c]">
                      <div className="mr-2.5">
                        <ShippingIcon />
                      </div>
                      <div className="text-xs font-condensed font-bold text-[#1c1c1c]">
                        {notice}
                      </div>
                    </div>
                  )}

                <div className="w-full flex items-start mt-5">
                  <div className="mr-2.5">
                    <AdventureAssurance />
                  </div>
                  <div className="text-xs font-condensed font-bold text-[#1c1c1c]">
                    <h1 className="mb-0 text-xs text-[#1c1c1c]">
                      AdventureAssurance™ Backed
                    </h1>
                    <p className="mb-0 text-[11.5px] mt-1.5 text-[#1c1c1c] font-normal font-sans">
                      Be satisfied with your gear throughout your adventures or
                      your money back.{" "}
                      <a className="underline italic" href="/">
                        Learn More.
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              {/* //Add To Wish List
    <div className="flex justify-end xl:justify-center w-full xl:w-auto">
    <AddToWishlist />
    </div>
    */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DefaultCustomProduct

DefaultCustomProduct.propTypes = {
  pageContext: PropTypes.shape({
    product: PropTypes.shape({
      title: PropTypes.string.isRequired,
      images: PropTypes.arrayOf(PropTypes.string).isRequired,
      variants: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          inventoryQuantity: PropTypes.string.isRequired,
          availableForSale: PropTypes.string.isRequired,
          inventoryPolicy: PropTypes.string.isRequired,
          selectedOptions: PropTypes.objectOf(PropTypes.string).isRequired,
          sku: PropTypes.string.isRequired,
          price: PropTypes.string.isRequired,
          storefrontId: PropTypes.string.isRequired,
          metafields: PropTypes.arrayOf(PropTypes.string).isRequired,
        }),
      ),
      shopifyId: PropTypes.string.isRequired,
      storefrontId: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      descriptionHtml: PropTypes.string.isRequired,
      collections: PropTypes.arrayOf(PropTypes.string).isRequired,
      productTypeSlug: PropTypes.string.isRequired,
      productType: PropTypes.string.isRequired,
      tags: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
    kitsCollection: PropTypes.shape({
      description: PropTypes.string.isRequired,
      descriptionHtml: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      handle: PropTypes.string.isRequired,
      image: PropTypes.objectOf(PropTypes.stiring).isRequired,
      products: PropTypes.arrayOf(PropTypes.string).isRequired,
      metafields: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
    partsCollection: PropTypes.shape({
      description: PropTypes.string.isRequired,
      descriptionHtml: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      handle: PropTypes.string.isRequired,
      image: PropTypes.objectOf(PropTypes.stiring).isRequired,
      products: PropTypes.arrayOf(PropTypes.string).isRequired,
      metafields: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
  }).isRequired,
}
